import {
  NumberOrNullOrUndefined,
  StringOrNullOrUndefined,
  BooleanOrNullOrUndefined,
} from 'src/app/shared/utils';

export class Invoice {
  id?: number;
  user_id?: number;
  employee?: InvoiceEmployee;
  location_id?: number;
  invoice_date?: Date | string;
  period_week_start?: string;
  period_week_end?: string;
  contract_type?: string;
  service_type?: string;
  status?: string;
  fixed_weekly_pay?: string;
  hourly_rate?: string;
  total_hours?: string;
  total_pay?: string;
  detail?: string;
  is_automated?: boolean;
  created_at?: Date;
  updated_at?: Date;
  deleted_at?: Date | null;

  constructor(data?: Partial<Invoice>) {
    Object.assign(this, data);
  }

  static build(data: Invoice): Invoice {
    return new Invoice({
      id: NumberOrNullOrUndefined(data.id),
      employee: data.employee
        ? {
            id: NumberOrNullOrUndefined(data.employee.id),
            type: StringOrNullOrUndefined(data.employee.type),
            display_name: StringOrNullOrUndefined(data.employee.display_name),
          }
        : undefined,
      location_id: NumberOrNullOrUndefined(data.location_id),
      invoice_date: StringOrNullOrUndefined(data.invoice_date),
      period_week_start: StringOrNullOrUndefined(data.period_week_start),
      period_week_end: StringOrNullOrUndefined(data.period_week_end),
      contract_type: StringOrNullOrUndefined(data.contract_type),
      service_type: StringOrNullOrUndefined(data.service_type),
      status: StringOrNullOrUndefined(data.status),
      fixed_weekly_pay: StringOrNullOrUndefined(data.fixed_weekly_pay),
      hourly_rate: StringOrNullOrUndefined(data.hourly_rate),
      total_hours: StringOrNullOrUndefined(data.total_hours),
      total_pay: StringOrNullOrUndefined(data.total_pay),
      detail: StringOrNullOrUndefined(data.detail),
      is_automated: BooleanOrNullOrUndefined(data.is_automated),
      created_at: data.created_at ? new Date(data.created_at) : undefined,
      updated_at: data.updated_at ? new Date(data.updated_at) : undefined,
      deleted_at: data.deleted_at ? new Date(data.deleted_at) : null,
    });
  }
}

export interface InvoiceEmployee {
  id?: number;
  type?: string;
  display_name?: string;
}
